<div class="flex gap-M pad-XL-XL-0 w-100 border-box">
	<app-diagram-breadcrumb class="w-100"></app-diagram-breadcrumb>

<!--	<div class="filter-panel-container bkg-white b-radius-9">-->
<!--		<app-icon-button color="accent" type="stroked" [img]="'assets/icons/settings.svg'" class="filter-panel-btn" panelClass="h-100-imp w-100-imp bkg-transparent"-->
<!--						 [disabled]="true">-->
<!--		</app-icon-button>-->
<!--	</div>-->

<!--	<div style="min-width: 100px;">-->
<!--		<app-text-button type="flat" panelClass="h-100-imp" [tooltip]="'page.diagram.filters.exportButton'|translate" (click)="exportDiagram()">-->
<!--			<img src="assets/icons/share.svg" alt="share">-->
<!--		</app-text-button>-->
<!--	</div>-->
	<div class="flex-align-center filter-bar bkg-white b-radius-9" style="padding: 3px;border: 0.5px solid #DCDCE9">
		<app-text-button type="default" color="primary" style="width: 43px; height: 43px;"
						 panelClass="h-100-imp pad-0-imp"
						 (click)="refresh()"
						 [disabled]="_loading"
						 [loading]="_refreshing">
			<div class="flex-center">
				<img src="assets/icons/refresh-cw-01.svg" height="18" alt=""/>
			</div>
		</app-text-button>
	</div>
</div>


<div class="mt-xl ml-xl mr-xl mb-xl canvas" #canvasContainer style="height: calc(100% - 210px);">

	<div *ngIf="isNotData" class="nodata flex f-d-col flex-align-center">
		<img src="assets/illustrations/diagram-nodata.svg" width="175" class="primary illustration">
		<div class="nodata-title text-center">
			{{ 'page.diagram.infrastructure.nodata-title' | translate}}
		</div>
		<div class="nodata-subtitle text-center w-60">
			{{ 'page.diagram.infrastructure.nodata-subtitle' | translate}}
		</div>
<!--		<app-text-button type="flat" color="accent" (click)="goToInfrastructure()">-->
<!--			{{ 'page.diagram.infrastructure.nodata-button' | translate }}-->
<!--		</app-text-button>-->
		<div class="nodata-box text-center" (click)="goToInfrastructure()">
			<span class="nodata-button">{{ 'page.diagram.infrastructure.nodata-button' | translate}}</span>
		</div>
	</div>

	<div *ngIf="isData" (mousedown)="$event.stopPropagation()" class="diagram-zoom">
<!--		<div class="selector"><img src="assets/icons/hand-select.svg" width="18" class="selector-img"></div>-->
<!--		<div class="arrow-button"><img src="assets/icons/card-arrow.svg" width="10" height="10" class="filter-primary arrow-img"></div>-->
<!--		<div class="separation-line"></div>-->
		<div class="diagram-zoom-button" (click)="onRecenter();" matRipple><img src="assets/icons/center.svg" width="18" class="filter-primary"></div>
		<div class="diagram-zoom-button" (click)="onZoomOut();" matRipple><img src="assets/icons/minus.svg" width="24" class="filter-primary"></div>
		<div class="diagram-zoom-info" *ngIf="getZoomLevel() >= 0">{{ getZoomLevel() | number: '1.0-0'}}%</div>
		<div class="diagram-zoom-info" *ngIf="getZoomLevel() < 0">- %</div>
		<div class="diagram-zoom-button" (click)="onZoomIn();" matRipple><img src="assets/icons/add.svg" width="14" class="filter-primary"></div>
<!--		<div class="separation-line"></div>-->
<!--		<div class="diagram-3d" (click)="changeView();">-->
<!--			<div class="diagram-3d-button">-->
<!--				<div class="button">3D</div>-->
<!--			</div>-->
<!--		</div>-->
	</div>

	<app-loading-progress></app-loading-progress>

	<!-- Scrollbars -->
	<div *ngIf="isData" class="scrollbar-container">
		<!-- Scrollbar horizontale -->
		<div class="scrollbar horizontal-scrollbar" *ngIf="showHorizontalScrollbar">
			<div class="scrollbar-track" (mousedown)="onScrollbarTrackClick($event, 'horizontal')">
				<div class="scrollbar-thumb"
					 [style.width.%]="getHorizontalThumbSize()"
					 [style.left.%]="horizontalScrollPosition"
					 (mousedown)="onScrollThumbMouseDown($event, 'horizontal')"></div>
			</div>
		</div>

		<!-- Scrollbar verticale -->
		<div class="scrollbar vertical-scrollbar" *ngIf="showVerticalScrollbar">
			<div class="scrollbar-track" (mousedown)="onScrollbarTrackClick($event, 'vertical')">
				<div class="scrollbar-thumb"
					 [style.height.%]="getVerticalThumbSize()"
					 [style.top.%]="verticalScrollPosition"
					 (mousedown)="onScrollThumbMouseDown($event, 'vertical')"></div>
			</div>
		</div>
	</div>

	<div *ngIf="isPopupVisible" class="overlay" (click)="closeServerList()"></div>
		<div *ngIf="isPopupVisible"
			 class="server-list-popup"
			 [style.left.px]="popupX"
			 [style.top.px]="popupY"
			 (click)="$event.stopPropagation()">
			<div class="server-button" *ngFor="let server of serversToDisplay" (click)="openDrawer(server.id)">
				<img [src]="searchIcon(server.type)" class="server-icon" alt="">
				{{ server.name || 'Serveur sans nom' }}
			</div>
		</div>

</div>
